// Shopify.formatMoney was previously provided by api.jquery.js — polyfill if absent
// https://help.shopify.com/en/manual/international/pricing/currency-formatting
if (window.Shopify && !Shopify.formatMoney) {
  Shopify.formatMoney = function(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '')
    const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/
    const formatString = format || Shopify.money_format || '$ {{amount}}'
    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = precision == null ? 2 : precision
      thousands = thousands || ','
      decimal = decimal || '.'
      if (isNaN(number) || number == null) return 0
      number = (number / 100).toFixed(precision)
      const parts = number.split('.')
      const dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands)
      const pennies = parts[1] ? decimal + parts[1] : ''
      return dollars + pennies
    }
    const match = formatString.match(placeholderRegex)
    let value = ''
    switch (match && match[1]) {
      case 'amount':                                  value = formatWithDelimiters(cents, 2); break
      case 'amount_no_decimals':                      value = formatWithDelimiters(cents, 0); break
      case 'amount_with_comma_separator':             value = formatWithDelimiters(cents, 2, '.', ','); break
      case 'amount_no_decimals_with_comma_separator': value = formatWithDelimiters(cents, 0, '.', ','); break
      case 'amount_with_apostrophe_separator':        value = formatWithDelimiters(cents, 2, "'", '.'); break
      case 'amount_no_decimals_with_space_separator': value = formatWithDelimiters(cents, 0, ' '); break
      case 'amount_with_space_separator':             value = formatWithDelimiters(cents, 2, ' ', ','); break
      case 'amount_with_period_and_space_separator':  value = formatWithDelimiters(cents, 2, ' ', '.'); break
      default:                                        value = formatWithDelimiters(cents, 2)
    }
    return formatString.replace(placeholderRegex, value)
  }
}
